import { createSlice } from '@reduxjs/toolkit'

// Function to create initial state with optional session key
const createInitialState = (initialSessionKey = '') => ({
  isEnabled: false,
  standardSessionKey: initialSessionKey, // SESSION_ID_1
  employeeSessionKey: '', // SESSION_ID_2
})

export const employeeDiscount = createSlice({
  name: 'employeeDiscount',
  initialState: createInitialState(),
  reducers: {
    setEmployeeDiscountEnabled: (state, action) => {
      state.isEnabled = action.payload
    },
    setStandardSessionKey: (state, action) => {
      // Always update the standard session key when provided
      state.standardSessionKey = action.payload
    },
    setEmployeeSessionKey: (state, action) => {
      // Always update the employee session key when provided
      state.employeeSessionKey = action.payload
    },
  },
})

export const { setEmployeeDiscountEnabled, setStandardSessionKey, setEmployeeSessionKey } =
  employeeDiscount.actions
